import { useEffect, useState } from "react";
import { ParamKeyValuePair } from "react-router-dom";
import { useQueryString, useQueryStringFilter } from "../../hooks";

import { IQueryStringNavLinks } from "../../interfaces-and-types";
import { View } from "./View";

interface IQuickTableFilterTabsProps {
  queryStringTabNavLinks: IQueryStringNavLinks;
  filterPrefix?: string;
  tabListType?: "" | "contained";
  containerClassName?: string;
}

export interface IQuickTableFilterTabsViewProps
  extends IQuickTableFilterTabsProps {
  activeTab: string;
  setQueryStringFilter: () => void;
}

export const QuickTableFilterTabs = (props: IQuickTableFilterTabsProps) => {
  const filterPrefixWithDot = !!props.filterPrefix
    ? `${props.filterPrefix}.`
    : "";

  const query = useQueryString();
  const activeTabOnUrl = query.get(
    `${filterPrefixWithDot}${props.queryStringTabNavLinks.query}`
  );

  const selectedIndexUrl = props.queryStringTabNavLinks.options.findIndex(
    (opt, i) => opt.value === activeTabOnUrl
  );

  const [defaultSelectedIndex, setDefaultSelectedIndex] = useState(0);
  useEffect(() => {
    setDefaultSelectedIndex(selectedIndexUrl > -1 ? selectedIndexUrl : 0);
  }, []);

  const [selectedIndex, setSelectedIndex] = useState(
    selectedIndexUrl > -1 ? selectedIndexUrl : 0
  );

  const defaultInit: ParamKeyValuePair[] =
    props.queryStringTabNavLinks.options.map((qst) => [
      props.queryStringTabNavLinks.query,
      qst.value,
    ]);

  const { setQueryStringFilter, clearQueryStringFilter } =
    useQueryStringFilter(defaultInit);

  const setQueryStringFilterWithPrefix = (queryKey: string, value: string) =>
    setQueryStringFilter(`${filterPrefixWithDot}${queryKey}`, value);

  // set active tab on url
  useEffect(() => {
    const queryKey = props.queryStringTabNavLinks.query;
    const selectedTabQueryValue =
      props.queryStringTabNavLinks.options[selectedIndex].value;

    selectedTabQueryValue === "all" ||
    selectedTabQueryValue === null ||
    selectedTabQueryValue === ""
      ? clearQueryStringFilter(queryKey)
      : setQueryStringFilter(
          `${filterPrefixWithDot}${queryKey}`,
          selectedTabQueryValue
        );
  }, [selectedIndex]);

  return (
    <View
      {...props}
      setQueryStringFilter={setQueryStringFilterWithPrefix}
      defaultSelectedIndex={defaultSelectedIndex}
      selectedIndex={selectedIndex}
      onChange={(value: any) => setSelectedIndex(value.selectedIndex)} // use with selectedIndex
      // tabListType={props.tabListType}
    />
  );
};
